export const IPOOTPVALIDATE_DATA = "IPOOTPVALIDATE_DATA";
export const IPOOTPVALIDATE_ERROR_DATA = "IPOOTPVALIDATE_ERROR_DATA";
export const IPOOTPVALIDATE_HIDE_ERROR_DATA = "IPOOTPVALIDATE_HIDE_ERROR_DATA";
export const IPOOTPVALIDATE_START_LOADER = "IPOOTPVALIDATE_START_LOADER";
export const IPOOTPVALIDATE_STOP_LOADER = "IPOOTPVALIDATE_STOP_LOADER";
